export default {
  path: '/climbing',
  name: 'climbing',
  component: () => import('@/views/climbing/Index'),
  redirect: { name: 'climbing-groups' },
  children: [
    {
      path: 'groups',
      component: () => import('@/views/climbing/groups/Index'),
      children: [
        {
          path: '',
          component: () => import('@/views/climbing/groups/list/Layout'),
          children: [
            {
              path: '',
              name: 'climbing-groups',
              component: () => import('@/views/climbing/groups/list/Upcoming'),
              meta: {
                title: 'Climbing groups',
                roles: ['general_manager', 'sales_manager', 'operations_manager', 'climbing_manager', 'climbing_supervisor', 'climbing_assistant', 'sales_supervisor', 'operations_supervisor', 'support']
              },
            },
            {
              path: 'in-tour',
              name: 'climbing-groups-tour',
              component: () => import('@/views/climbing/groups/list/InTour'),
              meta: {
                title: 'Climbing groups',
                roles: ['general_manager', 'sales_manager', 'operations_manager', 'climbing_manager', 'climbing_supervisor', 'climbing_assistant', 'sales_supervisor', 'operations_supervisor', 'support']
              },
            },
            {
              path: 'archive',
              name: 'climbing-groups-archive',
              component: () => import('@/views/climbing/groups/list/Archive'),
              meta: {
                title: 'Climbing groups',
                roles: ['general_manager', 'sales_manager', 'operations_manager', 'climbing_manager', 'climbing_supervisor', 'climbing_assistant', 'sales_supervisor', 'operations_supervisor', 'support']
              },
            },
          ]
        },
        {
          path: ':id',
          name: 'climbing-groups-detail',
          component: () => import('@/views/climbing/groups/detail/Layout'),
          redirect: { name: 'climbing-groups-detail-clients' },
          children: [
            {
              path: '',
              name: 'climbing-groups-detail-clients',
              component: () => import('@/views/climbing/groups/detail/Clients'),
              meta: {
                roles: ['general_manager', 'sales_manager', 'operations_manager', 'climbing_manager', 'climbing_supervisor', 'climbing_assistant', 'sales_supervisor', 'operations_supervisor', 'support']
              }
            },
            {
              path: 'np',
              name: 'climbing-groups-detail-np',
              component: () => import('@/views/climbing/groups/detail/NP'),
              meta: {
                roles: ['general_manager', 'climbing_manager', 'climbing_supervisor', 'climbing_assistant']
              }
            },
            {
              path: 'food',
              name: 'climbing-groups-detail-food',
              component: () => import('@/views/climbing/groups/detail/Food'),
              meta: {
                roles: ['general_manager', 'sales_manager', 'operations_manager', 'climbing_manager', 'climbing_supervisor', 'climbing_assistant', 'sales_supervisor', 'operations_supervisor']
              }
            },
            {
              path: 'transfers',
              name: 'climbing-groups-detail-transfers',
              component: () => import('@/views/climbing/groups/detail/Transfers'),
              meta: {
                roles: ['general_manager', 'climbing_manager', 'climbing_supervisor', 'climbing_assistant', 'operations_supervisor', 'support']
              }
            },
            {
              path: 'hotels',
              name: 'climbing-groups-detail-hotels',
              component: () => import('@/views/climbing/groups/detail/Hotels'),
              meta: {
                roles: ['general_manager', 'operations_manager', 'operations_supervisor', 'sales_supervisor', 'sales_manager', 'support']
              }
            },
            {
              path: 'bed-in-twin',
              name: 'climbing-groups-detail-bed-in-twin',
              component: () => import('@/views/climbing/groups/detail/BedInTwin'),
              meta: {
                roles: ['general_manager', 'operations_supervisor', 'sales_supervisor', 'sales_manager']
              }
            },
            {
              path: 'briefings',
              name: 'climbing-groups-detail-briefings',
              component: () => import('@/views/climbing/groups/detail/Briefings'),
              meta: {
                roles: ['general_manager', 'operations_manager', 'operations_supervisor', 'sales_supervisor', 'sales_manager']
              }
            },
            {
              path: 'arrivals',
              name: 'climbing-groups-detail-arrivals',
              component: () => import('@/views/climbing/groups/detail/Arrivals'),
              meta: {
                roles: ['general_manager', 'operations_supervisor', 'operations_manager']
              }
            },
            {
              path: 'additional-services',
              name: 'climbing-groups-detail-services',
              component: () => import('@/views/climbing/groups/detail/Services'),
              meta: {
                roles: ['general_manager', 'sales_manager', 'operations_manager', 'climbing_manager', 'climbing_supervisor', 'climbing_assistant', 'sales_supervisor', 'operations_supervisor', 'support']
              }
            },
            {
              path: 'tents',
              name: 'climbing-groups-detail-tents',
              component: () => import('@/views/climbing/groups/detail/Tents'),
              meta: {
                roles: ['general_manager', 'operations_manager', 'sales_manager', 'climbing_manager', 'climbing_supervisor', 'climbing_assistant', 'sales_supervisor', 'operations_supervisor', 'support']
              }
            },
            {
              path: 'requests',
              name: 'climbing-groups-detail-requests',
              component: () => import('@/views/climbing/groups/detail/Requests'),
              meta: {
                roles: ['general_manager', 'climbing_manager', 'operations_manager', 'climbing_supervisor', 'climbing_assistant', 'product_storage_storekeeper', 'sales_manager', 'sales_supervisor', 'operations_supervisor', 'support']
              }
            },
            {
              path: 'downloads',
              name: 'climbing-groups-detail-downloads',
              component: () => import('@/views/climbing/groups/detail/Downloads'),
              meta: {
                roles: ['general_manager', 'operations_manager', 'climbing_manager', 'climbing_supervisor', 'climbing_assistant', 'operations_supervisor', 'support', 'sales_supervisor']
              }
            },
            {
              path: 'uploads',
              name: 'climbing-groups-detail-uploads',
              component: () => import('@/views/climbing/groups/detail/Uploads'),
              meta: {
                roles: ['general_manager', 'climbing_supervisor', 'climbing_manager']
              }
            },
            {
              path: 'calculations',
              name: 'climbing-groups-detail-calculations',
              component: () => import('@/views/climbing/groups/detail/Calculations'),
              meta: {
                roles: ['general_manager']
              }
            },
          ]
        },
      ]
    },
    {
      path: 'groups-supply',
      component: () => import('@/views/climbing/groups-supply/Index'),
      children: [
        {
          path: '',
          name: 'climbing-groups-supply',
          component: () => import('@/views/climbing/groups-supply/List'),
          meta: {
            title: 'Climbing groups supply',
            roles: ['general_manager', 'climbing_supervisor']
          },
        },
        {
          path: ':id',
          component: () => import('@/views/climbing/groups-supply/detail/Layout'),
          children: [
            {
              path: '',
              name: 'climbing-groups-supply-detail-general',
              component: () => import('@/views/climbing/groups-supply/detail/General'),
              meta: {
                title: 'Climbing groups supply',
                roles: ['general_manager', 'climbing_supervisor']
              }
            },
            {
              path: 'equipment',
              name: 'climbing-groups-supply-detail-equipment',
              component: () => import('@/views/climbing/groups-supply/detail/Equipment'),
              meta: {
                title: 'Climbing groups supply',
                roles: ['general_manager', 'climbing_supervisor']
              }
            },
            {
              path: 'kitchen',
              name: 'climbing-groups-supply-detail-kitchen',
              component: () => import('@/views/climbing/groups-supply/detail/Kitchen'),
              meta: {
                title: 'Climbing groups supply',
                roles: ['general_manager', 'climbing_supervisor']
              }
            },
            {
              path: 'electronics',
              name: 'climbing-groups-supply-detail-electronics',
              component: () => import('@/views/climbing/groups-supply/detail/Electronics'),
              meta: {
                title: 'Climbing groups supply',
                roles: ['general_manager', 'climbing_supervisor']
              }
            },
            {
              path: 'products',
              name: 'climbing-groups-supply-detail-products',
              component: () => import('@/views/climbing/groups-supply/detail/Products'),
              meta: {
                title: 'Climbing groups supply',
                roles: ['general_manager', 'climbing_supervisor']
              }
            },
            {
              path: 'oxygen',
              name: 'climbing-groups-supply-detail-oxygen',
              component: () => import('@/views/climbing/groups-supply/detail/Oxygen'),
              meta: {
                title: 'Climbing groups supply',
                roles: ['general_manager', 'climbing_supervisor']
              }
            },
            {
              path: 'medical',
              name: 'climbing-groups-supply-detail-medical',
              component: () => import('@/views/climbing/groups-supply/detail/Medical'),
              meta: {
                title: 'Climbing groups supply',
                roles: ['general_manager', 'climbing_supervisor']
              }
            },
          ]
        }
      ]
    },
    {
      path: 'briefings',
      component: () => import('@/views/climbing/briefings/Index'),
      children: [
        {
          path: '',
          component: () => import('@/views/climbing/briefings/Layout'),
          children: [
            {
              path: '',
              name: 'climbing-briefings-list',
              component: () => import('@/views/climbing/briefings/List'),
              meta: {
                title: 'Climbing briefings',
                roles: ['general_manager', 'operations_manager', 'operations_supervisor', 'finance_manager']
              }
            },
            {
              path: 'clients',
              name: 'climbing-briefings-clients',
              component: () => import('@/views/climbing/briefings/Clients'),
              meta: {
                title: 'Climbing briefings clients',
                roles: ['general_manager', 'operations_supervisor', 'finance_manager']
              }
            },
            {
              path: 'schedule',
              name: 'climbing-briefings-schedule',
              component: () => import('@/views/climbing/briefings/Schedule'),
              meta: {
                title: 'Climbing briefings schedule',
                roles: ['general_manager', 'operations_supervisor', 'finance_manager']
              }
            },
          ]
        },
        {
          path: ':id',
          component: () => import('@/views/climbing/briefings/detail/Layout'),
          children: [
            {
              path: '',
              name: 'climbing-briefings-detail-clients',
              component: () => import('@/views/climbing/briefings/detail/Clients'),
              meta: {
                title: 'Climbing briefing',
                roles: ['general_manager', 'operations_manager', 'operations_supervisor', 'finance_manager']
              }
            },
            {
              path: 'invoices',
              name: 'climbing-briefings-detail-invoices',
              component: () => import('@/views/climbing/briefings/detail/Invoices'),
              meta: {
                title: 'Climbing briefing',
                roles: ['general_manager', 'operations_supervisor', 'finance_manager']
              }
            },
          ]
        },
      ]
    },
    {
      path: 'birthdays',
      component: () => import('@/views/climbing/birthdays/List'),
      name: 'climbing-birthdays',
      meta: {
        title: 'Climbing birthdays',
        roles: ['general_manager', 'operations_manager', 'climbing_manager', 'climbing_supervisor', 'climbing_assistant', 'operations_supervisor']
      }
    },
    {
      path: 'mountain-crew',
      component: () => import('@/views/climbing/briefings/Index'),
      children: [
        {
          path: '',
          name: 'climbing-mountain-crew',
          component: () => import('@/views/climbing/mountain-crew/List'),
          meta: {
            title: 'Climbing mountain crew',
            roles: ['general_manager', 'climbing_supervisor']
          }
        },
        {
          path: ':id',
          component: () => import('@/views/climbing/mountain-crew/detail/Layout'),
          children: [
            {
              path: '',
              name: 'climbing-mountain-crew-profile',
              component: () => import('@/views/climbing/mountain-crew/detail/Profile'),
              meta: {
                title: 'Mountain crew profile',
                roles: ['general_manager', 'climbing_supervisor']
              }
            },
            {
              path: 'documents',
              name: 'climbing-mountain-crew-documents',
              component: () => import('@/views/climbing/mountain-crew/detail/Documents'),
              meta: {
                title: 'Mountain crew documents',
                roles: ['general_manager', 'climbing_supervisor']
              }
            },
            {
              path: 'position',
              name: 'climbing-mountain-crew-position',
              component: () => import('@/views/climbing/mountain-crew/detail/Position'),
              meta: {
                title: 'Mountain crew position',
                roles: ['general_manager', 'climbing_supervisor']
              }
            }
          ]
        },
      ]
    },
    {
      path: 'analytics',
      component: () => import('@/views/climbing/analytics/Layout'),
      children: [
        {
          path: '',
          name: 'climbing-analytics-general',
          component: () => import('@/views/climbing/analytics/General'),
          meta: {
            title: 'Climbing analytics',
            roles: ['general_manager', 'climbing_supervisor']
          },
        },
        {
          path: 'kinapa',
          name: 'climbing-analytics-kinapa',
          component: () => import('@/views/climbing/analytics/Kinapa'),
          meta: {
            title: 'Climbing analytics',
            roles: ['general_manager', 'climbing_supervisor']
          },
        }
      ]
    },
    {
      path: 'settings',
      component: () => import('@/views/climbing/settings/Layout'),
      children: [
        {
          path: '',
          name: 'climbing-settings-gps',
          component: () => import('@/views/climbing/settings/GPS'),
          meta: {
            title: 'Climbing settings',
            roles: ['general_manager', 'climbing_supervisor']
          },
        },
        {
          path: 'equipments',
          name: 'climbing-settings-equipments',
          component: () => import('@/views/climbing/settings/Equipments'),
          meta: {
            title: 'Climbing settings',
            roles: ['general_manager']
          },
        },
        {
          path: 'crew',
          name: 'climbing-settings-crew',
          component: () => import('@/views/climbing/settings/Crew'),
          meta: {
            title: 'Climbing settings',
            roles: ['general_manager']
          },
        },
      ]
    },
    {
      path: 'arrivals',
      component: () => import('@/views/climbing/arrivals/Index.vue'),
      children: [
        {
          path: '',
          name: 'climbing-arrivals-list',
          component: () => import('@/views/climbing/arrivals/List'),
          meta: {
            title: 'Climbing arrivals list',
            roles: ['general_manager', 'operations_supervisor', 'operations_manager']
          },
        },
        {
          path: ':id',
          name: 'climbing-arrivals-detail',
          component: () => import('@/views/climbing/arrivals/Detail'),
          meta: {
            title: 'Climbing arrivals detail',
            roles: ['general_manager', 'operations_supervisor', 'operations_manager']
          },
        }
      ]
    },
  ]
}
